module.exports = __webpack_public_path__ + "static/mayur-profile.e2622151.png";


//////////////////
// WEBPACK FOOTER
// ./assets/mayur-profile.png
// module id = 344
// module chunks = 144251824217401